import React, { ReactElement, useEffect, useState } from 'react'
import styles from './Spinner.module.scss'

interface SpinnerProps {
    loadingMsg?: string;
}
function Spinner(props: SpinnerProps): ReactElement {
    const [show, setShow] = useState(false)
    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(!show)
        }, 3000);
        return () => clearTimeout(timer);
      }, []);
      
    return (
        <div className={styles.spinnerContainer}>
            <div className={styles.loader}></div>
            {props.loadingMsg && <p className={`${styles.legend} ${show ? styles.nowShow : ""}`}>{props.loadingMsg}</p> }
        </div>
    )
}

export default Spinner
